import React from "react";
import { motion } from "framer-motion";
import { ShieldAlert, ArrowRight, CreditCard, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PaymentRequired = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="inline-flex p-4 rounded-[32px] bg-red-500/10 border border-red-500/20 mb-8"
        >
          <ShieldAlert className="text-red-500 w-12 h-12" />
        </motion.div>
        
        <h1 className="text-4xl font-bold mb-4 tracking-tight">Activation Required</h1>
        <p className="text-gray-400 mb-8 leading-relaxed">
          Your FOZZIL ID is active, but you don't have an active license for our premium ecosystem services yet.
        </p>

        <div className="space-y-4">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate('/pricing-taels')}
            className="w-full py-4 rounded-[32px] bg-white text-black font-bold text-lg flex items-center justify-center gap-2"
          >
            <CreditCard size={20} />
            View Pricing Plans
            <ChevronRight size={20} />
          </motion.button>
          
          <button
            onClick={() => navigate('/')}
            className="w-full py-4 rounded-[32px] bg-white/5 border border-white/10 hover:bg-white/10 transition-colors font-medium text-gray-400"
          >
            Go Back Home
          </button>
        </div>

        <p className="mt-12 text-sm text-gray-600">
          Already paid? License activation may take up to 2 minutes. 
          <button className="text-blue-500 ml-1 hover:underline">Refresh Status</button>
        </p>
      </div>
    </div>
  );
};

export default PaymentRequired;
